import { Component, OnInit, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { IdpService } from '../auth/services/auth.service';
import { Router, NavigationEnd } from '@angular/router';
import { CommmonService } from '../utils/common.service';
import { EmployeeService } from '../home/services/employee.service';
import { EmployeesapService } from '../home/services/employeesap.service';
import { enviroment } from 'src/environments/environment';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss'],
})
export class NavBarComponent implements OnInit {
  @ViewChild(MatMenuTrigger) trigger!: MatMenuTrigger;
  isBeneficiariesFormRoute = false;
  isAdmin = false;
  isPracticing = false;
  superAdmin = false;
  basePath = enviroment.archivo_contrato_colectivo;
  brochurePath = enviroment.archivo_brochure_beneficios;
  userName = '';
  employeeData:any;
  usuarioVigente = false;

  constructor(
    private _idpService: IdpService,
    private router: Router,
    private common_service: CommmonService,
    private employee_service: EmployeeService,
    private employeeSapService: EmployeesapService
  ) {}

  async ngOnInit() {
    this.routerDirection();
    this.userIsAdmin();
    this.employeeData = await this.employeeSapService.getEmployeeSapByRut();
    this.validacionUsuarioVigente()
    await this.getUserName();
  }

  routerDirection() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.getActualRoute(event.url);
      }
    });
  }

  cerrarSesion() {
    this._idpService.logout();
  }

  goToAdmin() {
    this.router.navigate(['/admin/requests']);
    localStorage.setItem('admin', 'true');
    this._idpService.admin.next(true);
  }

  goToHome() {
    this.router.navigate(['/welcome']);
  }

  goToPlan() {
    this.router.navigate(['/plans']);
  }

  getActualRoute(actualRoute: string) {
    this.isBeneficiariesFormRoute = actualRoute === '/beneficiaries-form';
  }

  goToRequests() {
    this.router.navigate(['/my-requests']);
  }

  async userIsAdmin() {
    const active_user = JSON.parse(this.common_service.getItemSessionStorage('id_token_claims_obj') ?? '{}');
    this.isAdmin = active_user.roles && active_user.roles.some((role: any) => role.startsWith('ADMIN_'));
    this.superAdmin = active_user.roles && active_user.roles.includes('SUPER_ADMIN');
    const employee_plan = await this.employee_service.get_employee_plan();
    this.isPracticing = employee_plan.description_plan === "Practicantes";
  }

  async getUserName() {
    try {
      const fullName = this.employeeData.colaborador.nombres || '';
      // Extraer solo el primer nombre
      this.userName = fullName.split(' ')[0] || '';
    } catch (error) {
      console.warn('Error obteniendo el nombre del colaborador:', error);
      // Fallback al método anterior
      try {
        const sessionData = this.common_service.getItemSessionStorage('id_token_claims_obj');
        if (sessionData) {
          const claims = JSON.parse(sessionData);
          const fallbackName = claims.name || claims.given_name || '';
          // También extraer solo el primer nombre del fallback
          this.userName = fallbackName.split(' ')[0] || '';
        }
      } catch (fallbackError) {
        console.warn('Error obteniendo el nombre del usuario desde sessionStorage:', fallbackError);
        this.userName = '';
      }
    }
  }

  async validacionUsuarioVigente(){
    try{
      const colaborador = this.employeeData.colaborador
      const c_estado = colaborador.estado
      const c_plan = colaborador.plan.descripcion.toLowerCase()
      this.usuarioVigente = (c_estado == 3 || c_plan.includes("jubilados")) && !this.isPracticing ? 
      true : false;
      }catch (e){
         console.warn("error", e)
      }
    
  }



}
